import type { XY } from "@designboticteam/core";

const EPSILON = 1e-6;

function arePointsEqual(a: XY, b: XY): boolean {
	const dx = a[0] - b[0];
	const dy = a[1] - b[1];

	return dx * dx + dy * dy <= EPSILON * EPSILON;
}

export { arePointsEqual };
